import reducer from "./reducer";
export { default as TypesOfScore } from "./components/index";
export { default as typesOfScoreReducerName } from "./constants";
export default reducer;
